import Action from '../../Action'
import './styles/ModalCreateException.css'
import { useState ,useEffect} from 'react';
import LoadSimple from '../../LoadSimple';
import { useFetch } from '../../../hooks/useFetch';
import SelectorAdmin from '../../SelectorAdmin';
import SelectorIcons from '../../SelectorIcons';
import { capitalizeFirstLetter } from '../../../utils/utils';
import { lang } from '../../generales/traduction';
import { logAuditAction } from '../../../utils/auditLogger';
const ModalCreateTrigger =({buscar_cis,handleShowPopup,setSearchTerm,languaje,mode,user,dataUsers,devices,server,setRegisterIsValid,groupSelected,setData,loading,setLoading,setError,setEditActive,editActive,closCreateCisModal})=>{
    const obtenerFechaActualLocal = () => {
        const ahora = new Date();
        const anio = ahora.getFullYear();
        const mes = String(ahora.getMonth() + 1).padStart(2, '0'); // El mes se cuenta desde 0
        const dia = String(ahora.getDate()).padStart(2, '0');
        const horas = String(ahora.getHours()).padStart(2, '0');
        const minutos = String(ahora.getMinutes()).padStart(2, '0');
      
        return `${anio}-${mes}-${dia}T${horas}:${minutos}`;
      };
    const [loadingM,setLoadingM]=useState(false);
    const [IpValid,setIpValid]=useState(true)
    const [matchPassword,setMatchPassword]=useState(false)
    const [disabled,setDisabled]=useState(true)
    const [host,sethost]=useState([])
    const [ManttoData,setManttoData]=useState({
        // name_brand:(editActive)?groupSelected.name_brand:"",
        trigger_id: (editActive)?groupSelected.trigger_id:0,
        severity_default_id: (editActive)?groupSelected.severity_default_id:0,
        name: (editActive)?groupSelected.name:"",
        description: (editActive)?groupSelected.description:"",
        event_message: (editActive)?groupSelected.event_message:"",
       
        })
    const reqField=()=>{
        return(
          <p className='reqField-gs'>
            *
          </p>
        )
      }
    const [hostName,setHostName]=useState("")
    const [hostLocation,setHostLocation]=useState("")
    const [hostActivate,setHostActivate]=useState(0)
    const levelsActual = dataUsers.data.map(obj => obj.level)
    const iconsActualString = dataUsers.data.map(obj => obj.icon)
    const iconsActual= iconsActualString.map(Number)
    // const tec_list=useFetch('cassia/ci_elements/technologies','','','GET',server)
    const [msgError,setMsgError]=useState("")
    const [listSearchIP,setListSearchIP]=useState(false)
    const dataMetric=useFetch('cassia/workflow_events','','','GET',server)

    //  const dataCriticalities=useFetch('cassia/criticalities','','','GET',server)
    //  const dataVars=useFetch('cassia/workflow_events/vars','','','GET',server)


    const handleChange=(e)=>{
        const {name,value}=e.target
        if(e.target.name==="criticality"){
            setManttoData((prevState)=>{
                return {
                    ...prevState,
                    [name]:value===""?0:(parseInt(value))
                }
                
            })
        }  else if(e.target.name==="status"){
            setManttoData((prevState)=>{
                return {
                    ...prevState,
                    [name]:(value=="Inactivo")?"Activo":"Inactivo"
                }
                
            })
        }else{
            setManttoData((prevState)=>{
                return {
                    ...prevState,
                    [name]:value
                }
                
            })
        }



        if(e.target.name==="ip"){
            if(value==""){
                setHostLocation("")
                setHostActivate(0)
                setIpValid(true)
                sethost([])
                setHostName("")
                setHostLocation("")
            }else{
                setIpValid(validateIp(value))
            }
           
           
          }
    }

    useEffect(()=>{
     
      if( ManttoData.trigger_id==0 || ManttoData.name==""  || ManttoData.description=="" ||
         ManttoData.event_message==""  || ManttoData.severity_default_id==0
      ){
          setDisabled(true)
      }else{
          setDisabled(false)
      }
},[ManttoData])


    const Registrar=()=>{
        let method='POST'
        let url_add=''
        if(editActive){
            method='PUT'
            url_add=groupSelected.event_id
        }

        let  body ={}



        setLoading(true)
        const fetchDataPost = async () => {
          
       try {
           // console.log(localStorage.getItem('access_token'))
           const response = await fetch(server.url+'/api/v1/cassia/workflow_events/'+url_add, {
             method: method,  
             headers: {
                "Accept": "application/json",
               // 'Content-Type': 'application/json',
               'Content-Type': 'application/json',
                 Authorization: `Bearer ${localStorage.getItem('access_token')}`,
               },
             body: JSON.stringify(ManttoData),
           });
           if (response.ok) {
             
             const data1 = await response.json();
             setLoading(false)
             // Manejo de la respuesta
             setData(data1)
             buscar_cis()
             handleShowPopup(capitalizeFirstLetter(lang[languaje]['completado']),capitalizeFirstLetter(((editActive)?lang[languaje]['regEditCorr']:lang[languaje]['regGenCorr'])),'', true)
             // console.log(data1);
             closCreateCisModal()
           setRegisterIsValid(true)
           
           const timer = setTimeout(() => {
             setRegisterIsValid(false)
             setEditActive(false)
             closCreateCisModal()
           }, 3000);
         
           } else {
             const data1 = await response.json();
             handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['regNoGenCorr']),data1.detail, false)
             throw new Error('Error en la solicitud');
           }
       } catch (error) {
              setHostName("")
              setManttoData({type_id:0,name:""})
              
          setLoading(false)
            // Manejo de errores
            setError(error)
            closCreateCisModal()
            setRegisterIsValid(true)
          //   handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['regNoGenCorr']),capitalizeFirstLetter(lang[languaje]['reportError']), false)
            const timer = setTimeout(() => {
              setRegisterIsValid(false)
              setEditActive(false)
              closCreateCisModal()
            }, 3000);
            console.error(error);
          }
        };

        fetchDataPost();
    }

    const buscar_host=(ip)=>{
        setLoadingM(true)
        const fetchDataPost = async () => {
          
       try {
           const response = await fetch(server.url+'/api/v1/cassia/ci_elements/search_host/'+ip, {
               method: 'GET',  
               headers: {
                 'Content-Type': 'application/json',
                 'accept': 'application/json',
                 'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
               },
             });
           //   console.log(response)
           if (response.ok) {
               const data1 = await response.json();
               setLoadingM(false)
               if(data1.data.length==0){
                   sethost([])
               setHostName("")
               setHostLocation("")
               setHostActivate(0)
                   setMsgError("La IP no existe o no esta dada de alta")
                   setIpValid(false)
               }else{
                   setIpValid(true)

               }
               sethost(data1.data)
               setDisabled(true)
           } else {
               const data1 = await response.json();
               throw new Error('Error en la solicitud');
           }
       } catch (error) {
            console.error(error);
          }
        };

        fetchDataPost();
    }
    const [eventId,setEventId]=useState(0)
    const changeOption=(option,index)=>{
        
        setEventId(option.value)
        // let attr=''
        // if(option.filter=='Severity'){
        //   attr='severity_default_id'
        // }else if(option.filter=='trigger'){
        //   attr='trigger_id'
        // }

        // setManttoData((prevState)=>{
        //     return {
        //         ...prevState,
        //         [attr]:option.value===""?0:(parseInt(option.value))
        //     }
            
        // })
        // setManttoRelation(option.value)
            
    }

    const [fecha, setDate] = useState('2023-09-28')
    const validateIp= (ip) => {
        const ipRegex = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
        let result = ipRegex.test(ip);
        if(result){
            buscar_host(ip)
        }else{
            setHostLocation("")
            setMsgError("Direccion ip no valida")
            sethost([])
                setHostName("")
                setHostLocation("")
                setHostActivate(0)
        }
        return result;
    };
    const [resultList,setResultList]=useState([])


    //   console.log(resultList)

    const closeListSearch=()=>{
        setListSearchIP(false)
    }
    const handleKeyPress = (e) => {
      // Permitir solo números, teclas de control y el punto decimal
      const charCode = e.charCode;
      if (
        (charCode >= 48 && charCode <= 57) || // Números 0-9
        charCode === 46 || // Punto decimal
        charCode === 8 || // Retroceso
        charCode === 37 || // Flecha izquierda
        charCode === 39 ||// Flecha derecha
        charCode === 45 //  negativo
      ) {
        return;
      } else {
        e.preventDefault();
      }
    };
    const handlePaste = (e) => {
      const paste = (e.clipboardData || window.clipboardData).getData('text');
      if (!/^-?\d*\.?\d*$/.test(paste)) {
        e.preventDefault();
      }
    };
    const Eliminar=()=>{
      
     setLoading(true)
      setLoadingM(true)
        const fetchDataPost = async () => {
          
       try {
           const response = await fetch(server.url+'/api/v1/cassia/workflow_events/active/'+eventId, {
           // const response = await fetch(server.url+'/api/v1/cassia/device_metrics/'+user.id, {
             method: 'PUT',  
             headers: {
               'Content-Type': 'application/json',
               Authorization: `Bearer ${localStorage.getItem('access_token')}`,
             },
             body:JSON.stringify({
               "closed_at":""
             })
           });
           if (response.ok) {
             
             const data1 = await response.json();
             setLoadingM(false)
             setLoading(false)
             // Manejo de la respuesta
             setData(data1)
             buscar_cis()
            handleShowPopup(capitalizeFirstLetter(lang[languaje]['completado']),capitalizeFirstLetter(((editActive)?lang[languaje]['regEditCorr']:lang[languaje]['regGenCorr'])),'', true)
             
             logAuditAction(
                 editActive ? "Editar" : "Crear",
                 `Evento ID: ${eventId}`,
                 "Eventos"
             );

             // console.log(data1);
             closCreateCisModal()
             
             // console.log(data1);
           } else {
               const data1 = await response.json();
               setLoadingM(false)
               // closDeleteUserModal()
               handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['regDeleteNoCorr']),data1.detail, false)

               throw new Error('Error en la solicitud');
           }
       } catch (error) {
            // Manejo de errores
            // handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['regDeleteNoCorr']),capitalizeFirstLetter(lang[languaje]['reportError']), false)
            setError(error)
            console.error(error);
          }
        };
    
        fetchDataPost();
        
  }
    const {trigger_id,name,description,event_message,severity_default_id}=ManttoData;
    return(
        <div className="modal-GS-content">
            <div className='card-modal-gs modal-verificate'>
                <div className='head-card-modal-gs'>
                    <div className='title-head-card-modal-gs'>
                        {((editActive)?lang[languaje]['editar'].toUpperCase():lang[languaje]['crear'].toUpperCase())+' '+lang[languaje]['evento'].toUpperCase()}
                    </div>
                </div>
                <div className='content-card-modal-gs' style={{overflowY: 'scroll',scrollbarWidth: 'thin'}}>
                
                                    <div className="form-GS-box"> 
                                      <div className="cont-msg-alert-confirm-action">
                            <div className="compact-msg-alert-confirm-action">
                                <img  className='icon-msg-alert' src={"/iconos/warning.png"}alt="Icono" style={{width:'30px',height:'30px',marginRight:'10px'}}/>
                                <div className="msg-alert-txt-confirm-action">

                                    {'Esta es una version DEMO de SAIMONTECH por lo cual no se pueden crear nuevos eventos, aqui se le proporciona una lista  precargada de eventos que podra dar de alta.'}
                                </div>
                            </div>
                            
                        </div>

                        { (!dataMetric.loading && dataMetric.data && dataMetric.data.data && dataMetric.data.data.filter(elemento => elemento.active === 0).length === 0) && (
                            <div className="cont-msg-alert-confirm-action" style={{marginTop:'10px', marginBottom:'15px'}}>
                                <div className="compact-msg-alert-confirm-action">
                                    <img className='icon-msg-alert' src={"/iconos/warning.png"} alt="Icono" style={{width:'30px',height:'30px',marginRight:'10px'}}/>
                                    <div className="msg-alert-txt-confirm-action">
                                        {'Se necesitan eliminar eventos de la tabla para que sean opciones elegibles para esta simulación.'}
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* <div className="user-box-GS "  style={{height:'10%'}}>
                                     </div> */}
                                    <div className="user-box-GS "  style={{height:'15%'}}>
                                        {
                                            (dataMetric.loading)?<p style={{color:'var(--txt-color)'}}> {capitalizeFirstLetter(lang[languaje]['CargandoDatos'])} . . .</p>:
                                            <>
                                                { (dataMetric.data && dataMetric.data.data && dataMetric.data.data.filter(elemento => elemento.active === 0).length === 0) ? (
                                                    <div style={{width:'100%', pointerEvents:'none', opacity: 0.5}}>
                                                        <SelectorAdmin placeholder={'Seleccionar nivel...'} opGeneral={true} txtOpGen={''}  opt_de={0} origen={'Admin'} data={[]} loading={false}  titulo='event_wf' selectFunction={changeOption} index={0}></SelectorAdmin>
                                                    </div>
                                                ) : (
                                                    <SelectorAdmin placeholder={'Seleccionar nivel...'} opGeneral={true} txtOpGen={''}  opt_de={(trigger_id==null)?0:trigger_id} origen={'Admin'} data={dataMetric.data.data.filter(elemento => elemento.active === 0)}   loading={dataMetric.loading}  titulo='event_wf' selectFunction={changeOption} index={0}></SelectorAdmin>
                                                ) }
                                            </>
                                        }
                                        <label className='label-GS'>{capitalizeFirstLetter(lang[languaje]['evento'])}{(eventId==0)?reqField():''}</label>   
                                    </div>
                                     
                                   
{/*                                     
                                    <div className="user-box-GS"  style={{height:'15%'}}>
                                    <input required name="name"  type="text" value={name}
                                    onChange={handleChange}  />
                                        <label className='label-GS  '>{capitalizeFirstLetter(lang[languaje]['nombre'])}{(name=="")?reqField():''}</label>
                                        
                                    </div>
                                    <div className="user-box-GS"  style={{height:'15%'}}>
                                    <input required name="description"  type="text" value={description}
                                    onChange={handleChange}  />
                                        <label className='label-GS  '>{capitalizeFirstLetter(lang[languaje]['descripcion'])}{(description=="")?reqField():''}</label>
                                        
                                    </div>
                                    <div className="user-box-GS"  style={{height:'25%'}}>
                                   
                                     <textarea id="comentarios" className='txtAreaGS' name="event_message"  value={event_message} onChange={handleChange} placeholder={capitalizeFirstLetter(lang[languaje]['txtAreaMsg'])}></textarea>
                                     
                                        <label className='label-GS  '>{capitalizeFirstLetter(lang[languaje]['msgEvento'])}{(event_message=="")?reqField():''}</label>
                                        <div className='infoCreateContent tooltip-container'>
                                        <img
                                            src={
                                              "/iconos/info.png"
                                            } 
                                            name="info"  title='info' className="btnAction delteException" style={{width:'35%'}}
                                          />
                                          <div className="tooltip-content">
                                            <p>Puedes utilizar las siguientes palabras clave:</p>
                                            <br></br>
                                            {
                                              (dataVars.loading)?'...':
                                              <ul className="tooltip-list">
                                                {
                                                  dataVars.data.data.map((element,index)=>(
                                                    <li>{element.value}</li>
                                                  ))
                                                }
                </ul>
                                            }
            </div>
                                        </div>
                                    </div> */}
{/*                                     
                                    <div className="user-box-GS "  style={{height:'15%'}}>
                                        {
                                            (dataCriticalities.loading)?<p style={{color:'var(--txt-color)'}}> {capitalizeFirstLetter(lang[languaje]['CargandoDatos'])} . . .</p>:
                                            <SelectorAdmin placeholder={'Seleccionar nivel...'} opGeneral={true} txtOpGen={''}  opt_de={(severity_default_id==null)?0:severity_default_id} origen={'Admin'} data={dataCriticalities.data.data}   loading={dataCriticalities.loading}  titulo='Severity' selectFunction={changeOption} index={0}></SelectorAdmin>
                                        }
                                        <label className='label-GS'>{capitalizeFirstLetter(lang[languaje]['severidad'])}{(severity_default_id==0)?reqField():''}</label>   
                                    </div>
                                    */}
                                
                                   
                                    
                                    
                                    <div className="user-box-GS" style={{height:'15%'}}>
                                        {
                                            (loading)?<LoadSimple></LoadSimple>
                                            :
                                            <>
                                            <Action disabled={false} origen='Cancelar' titulo={capitalizeFirstLetter(lang[languaje]['cancelar'])}  action={closCreateCisModal}/>
                                            <Action disabled={eventId==0} origen='Azul' titulo={capitalizeFirstLetter(lang[languaje]['guardar'])}  action={Eliminar}/>
                                            </>
                                            // <Action disabled={disabled} origen='Login' titulo='Guardar'  action={Registrar}/>
                                        }
                                            
                                    {
                                        // (registerIsValid && data.message!=="User deleted successfully")?<span className='form-msg-ok'>Usuario registrado correctamente</span>:''
                                    }
                                        
                                    </div>
                                </div>
                </div>
                </div>
        </div>
    )
}

export default ModalCreateTrigger